import {
  ListCard,
  RightMainContainer,
  HeaderContainer,
  PrimaryHeading,
  MainButton,
  BodyContainer,
  ListIconWrapper,
  InputField,
  PopOver,
  PopUpListing,
  AddFromTemplateLibrary,
  Loader,
  LoadingListCards,
  TemplateNotFound,
  FiltersList,
  UserAvatar,
} from "commonUI";
import { AddIcon, CloudDownloadIcon } from "allIcons";
import {
  useAddDefaultMember,
  useAddUsertoSingleWeb,
  useAddUsertoWP,
  useDefaultMembers,
  useMembers,
  useRemoveDefaultMember,
  useRemoveMemberFromWeb,
  useSiteRelateUsers,
} from "api/usersModule/members";
import { useDeferredValue, useEffect, useState } from "react";
import {
  isEqual,
  Modules,
  parse,
  search,
  useSearch,
  useUtilities,
} from "helpers";
import { useRoles } from "api/usersModule/roles";
import { useSites } from "api/sites";
import {
  libraryItemFiltering,
  libraryItemSorting,
} from "filterAndSort/templateLibrary";
import { useUserPermissions } from "hooks/user";
import { useUserLimitReached } from "hooks/plan";
import { USERTYPE } from "usersModule/enums";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function UserTab() {
  const { web = null } = useSearch();
  const { data } = useSites();
  const siteDetails = data?.site_details?.total_sites?.find((site) =>
    isEqual(site.dl_website_id, web)
  );
  const { data: members, isLoading: loadingMembers } = useMembers();
  const { data: users, isLoading } = useDefaultMembers();
  const { data: siteUsers, isLoading: loadingSiteUsers } = useSiteRelateUsers();
  const { data: roles } = useRoles();
  const { mutateAsync: addUsertoWP, isLoading: addingUserToWP } =
    useAddUsertoWP();
  const { mutateAsync: addDefaultMember, isLoading: isAdding } =
    useAddDefaultMember();
  const { mutate: removeDefaultMember, isLoading: isRemoving } =
    useRemoveDefaultMember();
  const { mutateAsync: addtoSingleWebsite, isLoading: addingUsertoWeb } =
    useAddUsertoSingleWeb();
  const { mutateAsync: removeFromSingleWebsite, isLoading: removingUsertoWeb } =
    useRemoveMemberFromWeb();
  const { navigate } = useUtilities();
  const {
    add_new_items_to_site_template,
    add_items_from_template_library,
    remove_items_from_site_template,
    edit_item_details_in_site_template,
    app_users_view_users,
    isLoading: isPermissionsLoading,
  } = useUserPermissions();
  const [membersAndClientList, setMembersAndClientList] = useState({
    members: [],
    clients: [],
  });

  const { isLimitReached } = useUserLimitReached();

  const [searchText, setSearchText] = useState("");
  const defferedSearch = useDeferredValue(searchText);
  const [filterData, setFilterData] = useState({});

  useEffect(() => {
    if (isPermissionsLoading) return;
    if (!app_users_view_users) {
      navigate("/dashboard");
      return;
    }
  }, [isPermissionsLoading, app_users_view_users, navigate]);

  useEffect(() => {
    if (!isLoading) {
      setMembersAndClientList({
        members: (web ? siteUsers : members).filter(
          (ele) =>
            (isEqual(ele.is_owner, 1) ||
              isEqual(ele.user_type, USERTYPE.TEAM_MEMBER)) &&
            search(`${ele.name} ${ele.last_name}`, defferedSearch) &&
            (!web && !isEqual(ele.is_owner, 1)
              ? isEqual(ele.default_tem, "1")
              : true)
        ),
        clients: (web ? siteUsers : members).filter(
          (ele) =>
            isEqual(ele.user_type, "Client") &&
            search(`${ele.name} ${ele.last_name}`, defferedSearch) &&
            (!web ? isEqual(ele.default_tem, "1") : true)
        ),
      });
    }
  }, [isLoading, users, defferedSearch, members, web, siteUsers]);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);

  const applySorting = (oder, orderBy) => {
    setMembersAndClientList({
      members: libraryItemSorting(
        oder,
        orderBy,
        membersAndClientList.members,
        "name"
      ),
      clients: libraryItemSorting(
        oder,
        orderBy,
        membersAndClientList.clients,
        "name"
      ),
    });
  };

  const applyFilter = ({
    selectedFilter,
    selectedTags,
    selectedLibrarySource,
    ...data
  }) => {
    setFilterData({
      ...data,
      selectedTags,
      selectedLibrarySource,
      selectedFilter,
    });
    setMembersAndClientList({
      members: libraryItemFiltering(
        selectedFilter,
        selectedTags,
        selectedLibrarySource,
        (web ? siteUsers : users).filter(
          (ele) =>
            isEqual(ele.user_type, "Team Member") || isEqual(ele.is_owner, 1)
        ),
        "user_type",
        (item) => item.roles.role_title
      ),
      clients: libraryItemFiltering(
        selectedFilter,
        selectedTags,
        selectedLibrarySource,
        (web ? siteUsers : users).filter((ele) =>
          isEqual(ele.user_type, "Client")
        ),
        "user_type",
        (item) => item.roles.role_title
      ),
    });
  };

  return (
    <>
      <RightMainContainer>
        <Loader
          show={
            isAdding ||
            isRemoving ||
            addingUserToWP ||
            addingUsertoWeb ||
            removingUsertoWeb
          }
          loader="block"
        />
        <HeaderContainer>
          <PrimaryHeading>{t("siteSetting.users.title")}</PrimaryHeading>
          <div className={"relative"}>
            {add_new_items_to_site_template ||
            add_items_from_template_library ? (
              <MainButton
                onClick={() => {
                  setOpenAddModal(true);
                }}
              >
                <AddIcon />
                {t("button.add")}
              </MainButton>
            ) : (
              ""
            )}
            <PopOver
              toolTip={{ vertical: "top", right: "30px" }}
              open={openAddModal || addUserModal}
              onClose={() => {
                setOpenAddModal(false);
                setAddUserModal(false);
              }}
              style={{
                top: "calc(100% + 10px)",
                right: "0",
                bottom: "auto",
              }}
            >
              {addUserModal ? (
                <AddFromTemplateLibrary
                  heading={t("siteSetting.users.addUserFromUserLibrary")}
                  isLoading={loadingMembers}
                  data={members
                    .filter((ele) => {
                      if (isEqual(ele.is_owner, 1)) return false;
                      if (web) {
                        let parsedContent = ele?.website_id?.includes("[")
                          ? parse(ele.website_id)
                          : ele.website_id;
                        return !parsedContent?.includes(web);
                      } else {
                        return !isEqual(ele.default_tem, "1");
                      }
                    })
                    .map((item) => ({
                      ...item,
                      title: item.name + " " + item.last_name,
                      onClick: () => {
                        if (web) {
                          addtoSingleWebsite({
                            user_id: item.id,
                            website_id: web,
                          }).then((data) => {
                            if (data.status_code === 200 && siteDetails) {
                              addUsertoWP({
                                web_url: siteDetails.web_url,
                                email: item.email,
                                first_name: item.name,
                                last_name: item.last_name,
                                wpsl_user_id: item.id,
                                wp_user_role: item.wp_user_role,
                                "HTTP-DL-WEBSITE-KEY":
                                  siteDetails.dl_website_id,
                              }).catch((err) => console.log(err));
                            }
                          });
                        } else {
                          addDefaultMember({
                            data: { id: item.id, website_id: web },
                          });
                        }
                      },
                      icon: (
                        <ListIconWrapper className="bg-white">
                          <UserAvatar user={item} />
                        </ListIconWrapper>
                      ),
                    }))}
                  emptyTemplate={{
                    label: t("siteSetting.users.user"),
                    linkLabel: t("siteSetting.users.user"),
                    link: isLimitReached
                      ? ""
                      : `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/add${web ? `?web=${web}` : ""}`,
                  }}
                />
              ) : (
                <PopUpListing
                  data={[
                    add_items_from_template_library && {
                      title: t("common.addOption.fromAccount"),
                      icon: <CloudDownloadIcon />,
                      onClick: () => {
                        setAddUserModal(true);
                      },
                      arrow: true,
                    },
                    isLimitReached || !add_new_items_to_site_template
                      ? null
                      : {
                          title: t("siteSetting.users.addOption.createNewUser"),
                          icon: <AddIcon />,
                          onClick: () => {
                            navigate(
                              `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/add${
                                web ? `?web=${web}` : ""
                              }`
                            );
                          },
                        },
                  ].filter((_) => _)}
                />
              )}
            </PopOver>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <InputField
            searchIcon
            filter
            placeholder={t("input.search.placeholder")}
            showTags={false}
            value={searchText}
            setValue={setSearchText}
            filterList={
              roles
                ?.filter((_) => !isEqual(_.nick, "owner"))
                .map((_) => ({
                  id: _.id,
                  title: _.role_title,
                  user_role: _.id,
                  user_type: _.role_title,
                  module: Modules.ROLES,
                })) ?? []
            }
            filterData={filterData}
            filterTitle={t("filter.userRole.title")}
            filterAddTitle={t("filter.userRole.addRole")}
            applySorting={applySorting}
            onApplyFilter={applyFilter}
          />
          <FiltersList filterData={filterData} updateFilter={applyFilter} />
          {isLoading || loadingSiteUsers ? (
            <LoadingListCards />
          ) : membersAndClientList.members.length === 0 &&
            membersAndClientList.clients.length === 0 ? (
            <TemplateNotFound
              label={t("siteSetting.users.user")}
              linkLabel={isLimitReached ? "" : t("siteSetting.users.user")}
              link={
                isLimitReached
                  ? ""
                  : `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/add${web ? `?web=${web}` : ""}`
              }
            />
          ) : (
            ""
          )}
          {membersAndClientList.members.length > 0 ? (
            <PrimaryHeading className="text-17">
              {t("siteSetting.users.teamMembers")}
            </PrimaryHeading>
          ) : (
            ""
          )}
          {membersAndClientList.members.map((item, index) => {
            return (
              <ListCard
                data={`${item.name} ${item.last_name}`}
                editLink={
                  edit_item_details_in_site_template
                    ? `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/${item.id}`
                    : ""
                }
                link={
                  edit_item_details_in_site_template
                    ? `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/${item.id}`
                    : ""
                }
                strictLink
                backUrlOnEdit={false}
                deleteIcon
                crossIcon={
                  remove_items_from_site_template && !isEqual(item.is_owner, 1)
                }
                editIcon={edit_item_details_in_site_template}
                onCross={() => {
                  if (web) {
                    removeFromSingleWebsite({
                      user_id: item.id,
                      website_id: web,
                    });
                  } else {
                    removeDefaultMember(item.id);
                  }
                }}
                secondaryData={
                  item?.roles?.role_title ??
                  roles.find((_) => isEqual(_.id, item.user_role))
                    ?.role_title ??
                  ""
                }
                icon={
                  <ListIconWrapper className="bg-white">
                    <UserAvatar user={item} />
                  </ListIconWrapper>
                }
                showModalonCross
                deleteTitle={t("siteSetting.users.confirmDelete.title")}
                deleteButtonText={t("common.popup.button.confirm")}
                deleteMessage={
                  web
                    ? t("siteSetting.users.confirmDelete.forSite.message")
                    : t("siteSetting.users.confirmDelete.message")
                }
              />
            );
          })}

          {membersAndClientList.clients.length > 0 ? (
            <PrimaryHeading className="text-17">
              {t("siteSetting.users.clients")}
            </PrimaryHeading>
          ) : (
            ""
          )}
          {membersAndClientList.clients.map((item, index) => {
            return (
              <ListCard
                data={`${item.name} ${item.last_name}`}
                editLink={
                  edit_item_details_in_site_template
                    ? `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/${item.id}`
                    : ""
                }
                link={
                  edit_item_details_in_site_template
                    ? `/${web ? ModulePrefixes.SITE_SETTINGS : ModulePrefixes.SITE_TEMPLATE}/users/${item.id}`
                    : ""
                }
                backUrlOnEdit={false}
                deleteIcon
                crossIcon={remove_items_from_site_template}
                editIcon={edit_item_details_in_site_template}
                onCross={() => {
                  if (web) {
                    removeFromSingleWebsite({
                      user_id: item.id,
                      website_id: web,
                    });
                  } else {
                    removeDefaultMember(item.id);
                  }
                }}
                secondaryData={
                  item?.roles?.role_title ??
                  roles.find((_) => isEqual(_.id, item.user_role))
                    ?.role_title ??
                  ""
                }
                icon={
                  <ListIconWrapper className="bg-white">
                    <UserAvatar user={item} />
                  </ListIconWrapper>
                }
                showModalonCross
                deleteTitle={t("siteSetting.users.confirmDelete.title")}
                deleteButtonText={t("common.popup.button.confirm")}
                deleteMessage={
                  web
                    ? t("siteSetting.users.confirmDelete.forSite.message")
                    : t("siteSetting.users.confirmDelete.message")
                }
              />
            );
          })}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
